import { QA_PSEUDO_LOCALES, type Direction } from "./locale-registry";

export interface QaPseudoLocaleMetadata {
  languageTag: "en-XA" | "ar-XB";
  kind: "expansion" | "rtl";
  direction: Direction;
  production: false;
}

/** QA-only pseudo locales are metadata, never runtime/exposure candidates. */
export const qaPseudoLocaleMetadata = (raw: unknown): QaPseudoLocaleMetadata | null => {
  if (typeof raw !== "string") return null;
  const entries = QA_PSEUDO_LOCALES as QaPseudoLocaleMetadata[];
  return entries.find((entry) => entry.languageTag === raw && entry.production === false) ?? null;
};
